import Chip, { ChipProps } from '@mui/material/Chip'

export const FeaturedHostChip = (props: ChipProps): JSX.Element => {
  return (
    <Chip
      label='Featured host'
      variant='inverted'
      color='primary'
      size='small'
      sx={{ fontSize: '14px' }}
      {...props}
    />
  )
}
